import { useTranslation } from 'react-i18next';

import { Button, Icon, Menu, Text } from '@pukka/ui-components';

interface BrandsFloatingMenuProps {
  brandCount: number;
  parentCount: number;
  disableBulkMove?: boolean;
  hideDeleteFromAllOutlets?: boolean;
  onUncheckAll: () => void;
  onClickDelete: () => void;
  onClickDeleteAllOutlet: () => void;
  onClickMoveTo: () => void;
}

function BrandsFloatingMenu({
  onUncheckAll,
  brandCount,
  parentCount,
  disableBulkMove,
  hideDeleteFromAllOutlets,
  onClickDelete,
  onClickDeleteAllOutlet,
  onClickMoveTo,
}: BrandsFloatingMenuProps) {
  const { t } = useTranslation('library');

  const tlPrefix = 'brands.floatingMenu';

  return (
    <div
      data-testid="floating-menu"
      className="absolute bottom-3 -ml-1 flex w-[calc(100%+8px)] items-center justify-between rounded-lg bg-green-50 p-4 shadow-lg"
    >
      <div className="flex items-center">
        <Text>
          {brandCount > 0 && t(`${tlPrefix}.brands`, { count: brandCount })}
          {brandCount > 0 && parentCount > 0 && ` ${t(`${tlPrefix}.and`)} `}
          {parentCount > 0 && t(`${tlPrefix}.parents`, { count: parentCount })}
          {(brandCount > 0 || parentCount > 0) && ` ${t(`${tlPrefix}.selected`)}.`}
        </Text>
        <Button variant="nude-blue" className="border-none bg-transparent" onClick={onUncheckAll}>
          {t(`${tlPrefix}.deselectAll`)}
        </Button>
      </div>

      <Menu
        align="end"
        trigger={
          <Button icon="chevron-down" reverse variant="secondary" size="s" className="w-32">
            <div className="w-full">{t(`${tlPrefix}.actions`)}</div>
          </Button>
        }
      >
        <Menu.Option className="mt-2 w-60 text-red-500" onClick={onClickDelete}>
          <Icon icon="delete" size="sm" />
          {t(`${tlPrefix}.delete`)}
        </Menu.Option>
        {!hideDeleteFromAllOutlets && (
          <Menu.Option className="w-60 text-red-500" onClick={onClickDeleteAllOutlet}>
            <Icon icon="delete" size="sm" />
            {t(`${tlPrefix}.deleteAllOutlet`)}
          </Menu.Option>
        )}
        <Menu.Option disabled={disableBulkMove} className="mb-2 w-60" onClick={onClickMoveTo}>
          <Icon icon="swap" size="sm" />
          {t(`${tlPrefix}.moveTo`)}
        </Menu.Option>
      </Menu>
    </div>
  );
}

export { BrandsFloatingMenu };
